import { useEffect } from 'react'

/**
 * ページタイトルを設定するカスタムフック
 * @param title ページ固有のタイトル（例: "マイページ", "ログイン"）
 * @param siteName サイト名（デフォルト: "認定資格.com"）
 */
export function useDocumentTitle(title?: string, siteName: string = '認定資格.com') {
  useEffect(() => {
    if (title) {
      document.title = `${title} - ${siteName}`
    } else {
      document.title = siteName
    }
  }, [title, siteName])
}
